module.exports = __webpack_public_path__ + "static/media/cornell.c99a6d8a.png";